import {Link} from '@smart/react-components';
import {Heading, Icon, Text, TextButton} from '@smart/web-components';
import * as React from 'react';
import styles from './index.module.scss';

type NoResultProps = {
  heading: string;
  text: string;
  resetFiltersButtonLabel?: string;
  resetFiltersButtonHandler?: () => void;
  productCatalogueButtonLabel?: string;
  productCatalogueButtonHref?: string;
};

export const NoResult = ({
  heading,
  text,
  resetFiltersButtonLabel,
  productCatalogueButtonLabel,
  productCatalogueButtonHref,
  resetFiltersButtonHandler,
}: NoResultProps): JSX.Element => {
  return (
    <div className={`${styles.noResult}`}>
      <Icon className={`${styles.noResultIcon}`} name={`car--medium`} />
      <Heading
        className={`${styles.noResultHeading}`}
        variant={`headline-functional-400`}
      >
        {heading}
      </Heading>
      <Text className={`${styles.noResultText}`} variant={`paragraph-200`}>
        {text}
      </Text>
      {resetFiltersButtonLabel && resetFiltersButtonHandler && (
        <TextButton
          className={`${styles.noResultButton}`}
          variant={`primary`}
          size={`300`}
          onClick={resetFiltersButtonHandler}
        >
          {resetFiltersButtonLabel}
        </TextButton>
      )}
      {productCatalogueButtonHref && productCatalogueButtonLabel && (
        <Link
          className={`${styles.noResultButton}`}
          variant="secondary"
          href={productCatalogueButtonHref}
        >
          {productCatalogueButtonLabel}
        </Link>
      )}
    </div>
  );
};
